module.exports = __webpack_public_path__ + "static/corretores-c77872340e03b04960ab1ed290cadab8.png";